module.exports = __webpack_public_path__ + "static/media/Error.31ac14fd.svg";